import React, { useEffect, useState } from 'react';
interface Section {
  id: string;
  title: string;
}
interface OnThisPageProps {
  sections: Section[];
}
export function OnThisPage({
  sections
}: OnThisPageProps) {
  const [activeSection, setActiveSection] = useState<string>('');
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, {
      rootMargin: '-100px 0px -66%',
      threshold: 0
    });
    sections.forEach(section => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.observe(element);
      }
    });
    return () => observer.disconnect();
  }, [sections]);
  const handleClick = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  if (sections.length === 0) return null;
  return <div className="hidden xl:block w-56 flex-shrink-0" data-id="element-227">
      <div className="sticky top-24 pl-6 border-l border-gray-200" data-id="element-228">
        <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wider mb-4" data-id="element-229">
          On This Page
        </h4>
        <nav className="space-y-2" data-id="element-230">
          {sections.map(section => <button key={section.id} onClick={() => handleClick(section.id)} className={`block text-left text-sm transition-colors w-full truncate ${activeSection === section.id ? 'text-[#0B5FA5] font-medium' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-231">
              {section.title}
            </button>)}
        </nav>
      </div>
    </div>;
}